import{dew}from"dist/index.js";export default dew();